import { createContext } from 'preact'

// Support for both Preact 8 and 10
export const ControllerContext =
  typeof createContext === 'function' ? createContext(null) : null
